"use strict";

function add(total, opts) {
  var g = opts.g;
  return total + g(opts);
}

module.exports = add;